const useSpanHeading = (text = '', spanClass = 'text-blue') => text.replace(/\|(.+)\|/, `<span class="${spanClass}">$1</span>`);

export default useSpanHeading;
